/**
 * Format currency code according to XRPL standards
 * For standard 3-character codes, return as is
 * For longer codes, convert to hex with proper padding
 * 
 * @param {string} symbol - Currency code/symbol to format 
 * @returns {string} - Properly formatted currency code
 */
export const formatCurrencyCode = (symbol) => {
  if (!symbol) return null;
  
  // Remove any spaces and convert to uppercase
  const code = symbol.trim().toUpperCase();
  
  // For standard 3-character codes, return as is
  if (code.length <= 3) {
    return code;
  }
  
  // For longer codes, convert to hex representation with padding
  return code
    .padEnd(20, '\0')
    .split('')
    .map(c => c.charCodeAt(0).toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase();
};

/**
 * Convert string to hexadecimal string
 * 
 * @param {string} str - String to convert to hex
 * @returns {string} - Hexadecimal representation of the string
 */
export const convertStringToHex = (str) => {
  if (!str) return '';
  
  return str
    .split('')
    .map(c => c.charCodeAt(0).toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase();
};

// Add default export for compatibility
export default {
  formatCurrencyCode,
  convertStringToHex
}; 